import {
  CHECK_CADASTRAL_FIELDS_START,
  SET_ROSREESTR_DATA,
  SET_UNKNOWN_ERROR,
  UPDATE_CADASTRAL_FIELDS_META,
  SET_VALIDATION_ERROR,
  RESET_ROSREESTR_DATA,
} from '../../actions/rosreestrData';
import {
  IRosreestrDataState,
  EResponseStatus,
  ECadastralFieldsNames,
  EErrorType,
} from '../../types/reducers/rosreestrData';
import { TActions } from '../../types/actions';
import { defaultState } from './defaultState';
import { SET_CADASTRAL_FIELD_REQUIRED } from '../../actions/rosreestrData/setCadastralFieldRequired';
import { SET_REQUIRED_ERROR } from '../../actions/rosreestrData/setRequiredError';

export function rosreestrData(state: IRosreestrDataState = defaultState, action: TActions): IRosreestrDataState {
  switch (action.type) {
    case CHECK_CADASTRAL_FIELDS_START: {
      return {
        ...state,
        cadastralFieldsMeta: {
          buildingCadastralNumber: {
            ...state.cadastralFieldsMeta.buildingCadastralNumber,
            isChecking: action.payload.includes(ECadastralFieldsNames.BuildingCadastralNumber),
          },
          cadastralNumber: {
            ...state.cadastralFieldsMeta.cadastralNumber,
            isChecking: action.payload.includes(ECadastralFieldsNames.CadastralNumber),
          },
        },
      };
    }

    case SET_ROSREESTR_DATA: {
      return {
        ...state,
        ...action.payload,
        responseStatus: EResponseStatus.Success,
      };
    }

    case SET_UNKNOWN_ERROR: {
      return {
        ...state,
        cadastralFieldsMeta: {
          buildingCadastralNumber: {
            ...state.cadastralFieldsMeta.buildingCadastralNumber,
            isChecking: false,
          },
          cadastralNumber: {
            ...state.cadastralFieldsMeta.cadastralNumber,
            isChecking: false,
          },
        },
        responseStatus: EResponseStatus.Error,
      };
    }
    case UPDATE_CADASTRAL_FIELDS_META: {
      return {
        ...state,
        cadastralFieldsMeta: action.payload.reduce(
          (result, { key, error, checkedValue }) => ({
            ...result,
            [key]: {
              ...state.cadastralFieldsMeta[key],
              errors: {
                ...state.cadastralFieldsMeta[key].errors,
                [EErrorType.NotFoundError]: error,
                [EErrorType.RequiredError]: {
                  ...state.cadastralFieldsMeta[key].errors[EErrorType.RequiredError],
                  value: false,
                },
              },
              checkedValue,
              isChecking: false,
            },
          }),
          state.cadastralFieldsMeta,
        ),
      };
    }

    case SET_VALIDATION_ERROR: {
      const { key, value } = action.payload;

      return {
        ...state,
        cadastralFieldsMeta: {
          ...state.cadastralFieldsMeta,
          [key]: {
            ...state.cadastralFieldsMeta[key],
            errors: {
              ...state.cadastralFieldsMeta[key].errors,
              [EErrorType.ValidationError]: {
                ...state.cadastralFieldsMeta[key].errors[EErrorType.ValidationError],
                value,
              },
            },
          },
        },
      };
    }

    case RESET_ROSREESTR_DATA: {
      return defaultState;
    }

    case SET_CADASTRAL_FIELD_REQUIRED: {
      const { key, value } = action.payload;

      return {
        ...state,
        cadastralFieldsMeta: {
          ...state.cadastralFieldsMeta,
          [key]: {
            ...state.cadastralFieldsMeta[key],
            isRequired: value,
          },
        },
      };
    }

    case SET_REQUIRED_ERROR: {
      const { key, value } = action.payload;

      return {
        ...state,
        cadastralFieldsMeta: {
          ...state.cadastralFieldsMeta,
          [key]: {
            ...state.cadastralFieldsMeta[key],
            errors: {
              ...state.cadastralFieldsMeta[key].errors,
              [EErrorType.RequiredError]: {
                ...state.cadastralFieldsMeta[key].errors[EErrorType.RequiredError],
                value,
              },
            },
          },
        },
      };
    }

    default:
      return state;
  }
}
